import { UnderDevelopment } from '../../../utils/UnderDevelopment/UnderDevelopment';
import './OwnerResource.scss';

export const OwnerResource = () => {
    return (
        <UnderDevelopment />
    );
  };